import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import EquityMarketAdminPanelOfferItem from './EquityMarketAdminPanelOfferItem';
import { useEquityMarketAdminPanel } from '../context/EquityMarketAdminPanelContext';
import { tabs } from '../constants/Tabs';

const SellOffersTab: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEquityMarketAdminPanel();

  const isActive = data.selectedTab === tabs.SELL;

  return (
    <div
      className={`tab-pane fade ${isActive ? 'show active' : ''}`}
      role="tabpanel"
    >
      <div className="card card-bordered mb-4">
        <div className="card-inner">
          <h6 className="card-title mb-3">
            <em className="icon ni ni-wallet-out text-primary mr-2" />
            {t('AllSellOffers')}
          </h6>
          <p className="text-soft fs-13px mb-4">
            {t('OffersTabDescriptionSell')}
          </p>
          {data.sellOffers.length === 0 ? (
            <div className="text-center py-4">
              <em className="icon ni ni-inbox fs-3 text-soft d-block mb-2" />
              <p className="text-soft">{t('NoOffersAvailable')}</p>
            </div>
          ) : (
            <div className="row g-3">
              {data.sellOffers.map((offer) => (
                <EquityMarketAdminPanelOfferItem
                  key={offer._id}
                  offer={offer}
                  isSell
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <TablePagination
        totalRows={data.sellOffersCount}
        onChangePage={actions.handleChangeOffersPage}
        onChangeRowsPerPage={actions.handleChangeOffersRowsPerPage}
      />
    </div>
  );
};

export default SellOffersTab;
